import script from "./ReportPageExam.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPageExam.vue?vue&type=script&setup=true&lang=js"

import "./ReportPageExam.vue?vue&type=style&index=0&id=0a34ff84&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a34ff84"]])

export default __exports__